export const keyCodeTypes = {
  Enter: 'enter',
  ArrowUp: 'up',
  ArrowDown: 'down',
  ArrowLeft: 'left',
  ArrowRight: 'right',
  Esc: 'esc',
  Backspace: 'backspace',
  Space: 'space'
};
export const keyCode = {
  Enter: 13,
  Space: 32,
  ArrowDown: 40,
  ArrowLeft: 37,
  ArrowRight: 39,
  ArrowUp: 38,
  Esc: 27
};
